import React from 'react';
import { ONBOARDING_STEPS } from './onboardingSteps';
import '../../Advertiser/AdvertiserOnboarding/AdvertiserOnboarding.css';

export default function ScreenHostOnboardingChecklist({
    completedSteps,
    activeStepId,
    onSkip,
    onJumpToStep,
}) {
    const visibleSteps = ONBOARDING_STEPS.filter((s) => s.id !== 'done');

    return (
        <div className="advertiser-onboarding-checklist">
            <div className="advertiser-onboarding-checklist-header">
                <h4>Getting started</h4>
                <button type="button" className="advertiser-onboarding-checklist-skip" onClick={onSkip}>
                    Skip tour
                </button>
            </div>
            <ul>
                {visibleSteps.map((step) => {
                    const done = completedSteps.includes(step.id);
                    const current = step.id === activeStepId;
                    return (
                        <li
                            key={step.id}
                            className={`${done ? 'done' : ''} ${current ? 'current' : ''}`}
                        >
                            <span>{done ? '✓' : current ? '→' : '○'}</span>
                            <button
                                type="button"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    font: 'inherit',
                                    color: 'inherit',
                                }}
                                onClick={() => onJumpToStep(step.id)}
                            >
                                {step.label}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
